import {
  getCardViewV2GridColumnCount,
  getCardViewV2GridListContentContainerStyle,
} from '@/utils/card-view-v2-layout';
import { useLayoutContext } from '@/contexts/layout-context';
import { useMemo } from 'react';
import { ViewStyle } from 'react-native';

// Column count + scroll content inset
export function useCardViewV2ProductGridLayout(
  shouldUseGrid: boolean | undefined,
): {
  columnCount: number | undefined;
  listContentContainerStyle: ViewStyle | undefined;
} {
  const { appDimensions, layoutSize } = useLayoutContext();

  return useMemo(() => {
    if (!shouldUseGrid) {
      return {
        columnCount: undefined,
        listContentContainerStyle: undefined,
      };
    }

    const width = appDimensions.width;
    return {
      columnCount: getCardViewV2GridColumnCount(layoutSize, width),
      listContentContainerStyle: getCardViewV2GridListContentContainerStyle(
        layoutSize,
        width,
      ),
    };
  }, [shouldUseGrid, appDimensions.width, layoutSize]);
}
